import React, { useContext, useEffect, useState } from 'react'
import { Card, CardBody, IconButton, Checkbox, Spinner } from "@material-tailwind/react";
import { BiEdit } from 'react-icons/bi';
import { RxHamburgerMenu } from 'react-icons/rx';
import { Pagination, SearchAndAddBtn, Switch, THead } from '../../Components';
import { get_music_data, update_Music_Priority } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import { RiDeleteBinLine } from 'react-icons/ri';
import MusicModal from '../../Components/Modals/MusicModal';
import moment from 'moment'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

export const Music = ({ title }) => {
    const [isMusicPriority, setIsMusicPriority] = useState(false);


    const { setDeleteUpdateTag, setDeleteUpdateItem, deleteUpdateYes, setAddEditDeleteTag, setFormData, confirmationModalShow, setConfirmationModalShow, handleSwitchUpdate, isLoading, deleteUpdateTag, checkedValues, handleCheckboxChange, currentPage, totalPage, perPage, search, setDeleteUpdateYes, setIsLoading, setCurrentPage, setPerPage, setTotalPage, currentPageData, setCurrentPageData, filterDropdown, handleOpen, isAscending, sortData } = useContext(NewContext);
    const simpleFields = [
        // { name: "Preview", },
        { name: "Name", sortable: true, field: 'name' },
        { name: "Mp3 File", },
        // { name: "Created At", sortable: true, field: 'createdAt' },
        { name: "Updated At", sortable: true, field: 'updatedAt' },
    ];
    const dropdownFields = [{ name: "Premium" }, { name: "Active", }];
    const totalFields = simpleFields.length + dropdownFields.length + 2;

    const getMusicData = async (sortName = sortData, sortType = isAscending) => {
        setIsLoading(true);
        try {
            const getMusic = await get_music_data(search, filterDropdown, sortName, sortType);
            if (getMusic) {
                const { status, data } = getMusic;
                if (status) {
                    setCurrentPageData(data);
                } else {
                    setCurrentPageData([]);
                }
            }
        } catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    }

    const handleDragEnd = async (e) => {
        if (!e.destination) return;
        let tempData = Array.from(currentPageData);
        let [source_data] = tempData.splice(e.source.index, 1);
        source_data.priority = e.destination.index + 1;
        tempData.splice(e.destination.index, 0, source_data);
        let newData = tempData.map((_ele, i) => ({ ..._ele, priority: i + 1 }));
        const { data, status } = await update_Music_Priority({ updates: newData })
        if (status) {
            setCurrentPageData(data);
        }
        setIsMusicPriority(!isMusicPriority)
    };

    useEffect(() => {
        getMusicData(sortData, isAscending);
        setDeleteUpdateTag("");
    }, [deleteUpdateTag, deleteUpdateYes, search, filterDropdown, isMusicPriority, sortData, isAscending]);


    useEffect(() => {
        document.title = title;
    }, [title])

    return (
        <>
            <SearchAndAddBtn title={`Music`} addBtn={true} perPageCount={false} isSearch={false} resetFilterBtn={false} deleteUpdateTag='all-delete-music' />
            <Card className="overflow-hidden w-full rounded-md shadow-none">
                <CardBody className="overflow-x-auto w-100 py-2.5 px-[5px] card-body-scrollbar">

                    <DragDropContext onDragEnd={handleDragEnd}>

                        <table className="w-full min-w-max table-auto text-left ">
                            <THead simpleFields={simpleFields} dropdownFields={dropdownFields} />
                            <Droppable droppableId='droppable-1'>
                                {
                                    (provider) => (
                                        <tbody ref={provider.innerRef} {...provider.droppableProps}>
                                            {
                                                isLoading ?
                                                    <tr>
                                                        <td colSpan={totalFields} className='py-12'>
                                                            <div className="flex justify-center items-center">
                                                                <Spinner />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    : currentPageData?.length === 0 ?
                                                        <tr>
                                                            <td colSpan={totalFields} className='py-12 bg-gray-200'>
                                                                <div className="flex justify-center items-center">
                                                                    No Data Found
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        : currentPageData?.map((_ele, i) => {
                                                            const isLast = i === currentPageData?.length - 1;
                                                            const classes = `text-[#1E1627] ${isLast ? "p-4" : "p-[14.5px]"}`;

                                                            return (
                                                                <Draggable draggableId={_ele._id} key={_ele._id} index={i}>
                                                                    {
                                                                        (provider) => (
                                                                            <tr key={i} className='border-b border-blue-gray-50' ref={provider.innerRef} {...provider.draggableProps} {...provider.dragHandleProps}>
                                                                                <td className={classes}>
                                                                                    <Checkbox
                                                                                        className='w-[18px] h-[18px] border-[1.5px] rounded-[3.6px] border-[#1E3354] checked:bg-[#0047FF] checked:border-transparent'
                                                                                        id={`slider-${_ele._id}`}
                                                                                        value={`${_ele._id}`}
                                                                                        checked={checkedValues.includes(`${_ele._id}`)}
                                                                                        onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                                                                    />
                                                                                </td>
                                                                                <td className={`w-[350px] ${classes}`}>
                                                                                    <div className="flex items-center">
                                                                                        <span className={`font-normal text-[17px] ${!_ele.name && `text-gray-500`}`}>{_ele.name || `None`}</span>
                                                                                    </div>
                                                                                </td>
                                                                                <td className={classes}>
                                                                                    <audio src={_ele.mp3file} controlsList="nodownload" controls />
                                                                                </td>
                                                                                {/* <td className={classes}>
                                                                                    <div className="flex items-center">
                                                                                        <span className={`font-normal text-[17px] ${!_ele.createdAt && `text-gray-500`}`}>{moment(_ele?.createdAt).format('DD/MM/YYYY, hh:mm A')}</span>
                                                                                    </div>
                                                                                </td> */}
                                                                                <td className={classes}>
                                                                                    <div className="flex items-center">
                                                                                        <span className={`font-normal text-[17px] ${!_ele.updatedAt && `text-gray-500`}`}>{moment(_ele?.updatedAt).format('DD/MM/YYYY, hh:mm A')}</span>
                                                                                    </div>
                                                                                </td>
                                                                                {
                                                                                    ["isPremium", "isActive"].map((_is_ele, i) => (
                                                                                        <td className={classes} key={i}>
                                                                                            <div className="ml-1">
                                                                                                <Switch id={_ele._id} name={_is_ele} onChange={(e) => { setDeleteUpdateYes("update-music"); handleSwitchUpdate(e); }} checked={_ele[_is_ele]} />
                                                                                            </div>
                                                                                        </td>
                                                                                    ))
                                                                                }
                                                                                <td className={classes}>
                                                                                    <div className="flex items-center gap-2">
                                                                                        <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' onClick={() => { setDeleteUpdateYes("update-music"); setAddEditDeleteTag(`update`); setFormData(_ele); handleOpen() }}>
                                                                                            <BiEdit />
                                                                                        </IconButton>
                                                                                        {/* <IconButton className='bg-[#EAEDF3] text-[#0047FF] text-[21px] shadow-none hover:shadow-none' onClick={() => { setAddEditDeleteTag(`view`); setFormData(_ele); handleOpen() }}>
                                                                <IoEyeOutline />
                                                            </IconButton> */}
                                                                                        <IconButton className='bg-[#EAEDF3] text-[#F62929] text-[21px] shadow-none hover:shadow-none' onClick={() => { setDeleteUpdateYes("delete-music"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                                                            <RiDeleteBinLine />
                                                                                        </IconButton>
                                                                                    </div>
                                                                                </td>
                                                                                <td className={classes} {...provider.dragHandleProps}>
                                                                                    <RxHamburgerMenu size={24} />
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    }
                                                                </Draggable>
                                                            );
                                                        })
                                            }
                                            {provider.placeholder}
                                        </tbody>
                                    )
                                }
                            </Droppable>
                        </table>
                    </DragDropContext>
                </CardBody>
            </Card>
            {/* {
                totalPage > 1 &&
                <Pagination currentPage={currentPage} totalPage={totalPage} getData={getMusicData} />
            } */}
            <MusicModal />
        </>
    )
}
Music.defaultProps = {
    title: "Message | Music"
};



export default Music